export default __webpack_public_path__ + "static/media/baking-soda-water-1.b524c3f2.jpg";